import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import BSCard from "react-bootstrap/Card";
import Loadable from "react-loadable";
import Nav from "react-bootstrap/Nav";
import Spinner from "./Spinner";
import classNames from "classnames";
import { reloadAds } from "../store/pagedata";
import styles from "../styles/CardLists.module.scss";
import useDarkMode from "use-dark-mode";
import { useParams } from "react-router-dom";

const Loading = () => (
  <div className={styles.spinner}>
    <Spinner className="fa-3x" />
  </div>
);

const CardView = Loadable({ loader: () => import("./CardView"), loading: Loading });
const TableView = Loadable({ loader: () => import("./TableView"), loading: Loading });
const TextView = Loadable({ loader: () => import("./TextView"), loading: Loading });

const CardLists = () => {
  const darkMode = useDarkMode(false);
  const dispatch = useDispatch();
  const { dir, page, subpage } = useParams();
  const { isLoading } = useSelector((state) => state.pagedata);
  const unfilteredCardlists = useSelector(
    (state) => state.pagedata?.data.container.json_dict?.cardlists
  );
  const [key, setKey] = useState("card");

  useEffect(() => {
    const layout = JSON.parse(localStorage.getItem("edhrec_layout"));
    if (layout) {
      setKey(layout);
    }

    CardView.preload();
    TableView.preload();
    TextView.preload();
  }, []);

  useEffect(() => {
    localStorage.setItem("edhrec_layout", JSON.stringify(key));
    dispatch(reloadAds());
  }, [key]);

  if (!(isLoading || unfilteredCardlists)) {
    return null;
  }
  const isCombosPage = dir === "combos" && page && !subpage;
  const isCombosSubpage = dir === "combos" && !isCombosPage;

  // First cardlist on combos subpage is the combo itself,
  // which is rendered in Panels
  const cardlists = isCombosSubpage ? unfilteredCardlists?.slice(1) : unfilteredCardlists;

  return (
    <BSCard
      className={classNames(styles.container, { [styles.dark]: darkMode.value }, "shadow-sm")}
    >
      {!isCombosPage && (
        <div className={styles.header}>
          <Nav
            activeKey={key}
            className={styles.buttons}
            onSelect={(k) => {
              setKey(k);
            }}
            variant="pills"
          >
            <Nav.Item>
              <Nav.Link eventKey="card">Card View</Nav.Link>
            </Nav.Item>
            <Nav.Item>
              <Nav.Link eventKey="table">Table View</Nav.Link>
            </Nav.Item>
            <Nav.Item>
              <Nav.Link eventKey="text">Text View</Nav.Link>
            </Nav.Item>
          </Nav>
        </div>
      )}
      {isCombosPage || key === "card" ? (
        <CardView cardlists={cardlists} fallback={<Loading />} isCombosPage={isCombosPage} />
      ) : key === "table" ? (
        <TableView fallback={<Loading />} />
      ) : (
        <TextView
          cardlists={cardlists?.map((cardlist) => ({
            ...cardlist,
            cardviews: cardlist.cardviews.filter((cardview) => !cardview.dummy),
          }))}
          fallback={<Loading />}
        />
      )}
    </BSCard>
  );
};

export default CardLists;
